/**
 * src/components/agent/ChatComposerV2.styles.js
 *
 * Phase 82-04 — Chat System Unification, composer + menus.
 * Tokens only (src/styles.js). No raw hex.
 */

export const composerRootStyle = {
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  position: 'relative',
  background: 'var(--glass)',
  borderTop: '1px solid var(--bdr)',
};

export const composerRowStyle = {
  display: 'flex',
  alignItems: 'flex-end',
  gap: 6,
  padding: '8px 10px',
};

export const textareaWrapStyle = {
  flex: 1,
  minWidth: 0,
  display: 'flex',
  alignItems: 'stretch',
};

export const textareaStyle = {
  width: '100%',
  minHeight: 44,
  maxHeight: 200,
  padding: '12px 14px',
  borderRadius: 22,
  border: '1px solid var(--bdr)',
  background: 'var(--bg, var(--glass))',
  color: 'var(--t1)',
  fontSize: 14,
  lineHeight: 1.4,
  fontFamily: 'inherit',
  outline: 'none',
  resize: 'none',
  boxSizing: 'border-box',
  overflowY: 'auto',
};

export const sendBtnStyle = {
  minWidth: 44,
  minHeight: 44,
  width: 44,
  height: 44,
  border: 'none',
  background: 'var(--accent)',
  color: 'var(--bg, var(--card))',
  cursor: 'pointer',
  borderRadius: '50%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: 0,
  flexShrink: 0,
  transition: 'opacity 150ms',
};

export const sendBtnDisabledStyle = {
  ...sendBtnStyle,
  opacity: 0.4,
  cursor: 'default',
};

export const iconBtnStyle = {
  minWidth: 44,
  minHeight: 44,
  width: 44,
  height: 44,
  border: 'none',
  background: 'transparent',
  color: 'var(--tm)',
  cursor: 'pointer',
  borderRadius: 8,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: 0,
  flexShrink: 0,
};

export const iconBtnActiveStyle = {
  ...iconBtnStyle,
  color: 'var(--accent)',
  background: 'var(--accent-bg)',
};

export const metaRowStyle = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: 8,
  padding: '0 14px 6px',
  fontSize: 11,
  color: 'var(--tm)',
};

export const counterStyle = {
  fontVariantNumeric: 'tabular-nums',
};

export const counterWarnStyle = {
  ...counterStyle,
  color: 'var(--warn)',
  fontWeight: 600,
};

export const counterErrorStyle = {
  ...counterStyle,
  color: 'var(--bad)',
  fontWeight: 600,
};

/* ── Menus (slash + mention + attach) ─────────────────────── */

export const menuPopoverStyle = {
  position: 'absolute',
  left: 12,
  bottom: '100%',
  marginBottom: 6,
  width: 320,
  maxWidth: 'calc(100% - 24px)',
  zIndex: 1200,
  background: 'var(--card, var(--bg))',
  border: '1px solid var(--bdr)',
  borderRadius: 10,
  boxShadow: 'var(--shc)',
  display: 'flex',
  flexDirection: 'column',
  maxHeight: 320,
  overflow: 'hidden',
};

export const menuListStyle = {
  flex: 1,
  minHeight: 0,
  overflowY: 'auto',
  padding: '4px 0',
};

export function menuItemStyle(active) {
  return {
    display: 'flex',
    alignItems: 'center',
    gap: 10,
    width: '100%',
    minHeight: 44,
    padding: '8px 12px',
    border: 'none',
    background: active ? 'var(--accent-bg)' : 'transparent',
    color: active ? 'var(--accent)' : 'var(--t1)',
    fontSize: 13,
    cursor: 'pointer',
    fontFamily: 'inherit',
    textAlign: 'left',
  };
}

export const menuItemBodyStyle = {
  display: 'flex',
  flexDirection: 'column',
  gap: 2,
  minWidth: 0,
  flex: 1,
};

export const menuItemLabelStyle = {
  fontSize: 13,
  fontWeight: 600,
  color: 'inherit',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
};

export const menuItemDescStyle = {
  fontSize: 11,
  color: 'var(--tm)',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
};

export const menuItemTypeTagStyle = {
  fontSize: 10,
  fontWeight: 600,
  color: 'var(--tm)',
  textTransform: 'uppercase',
  letterSpacing: 0.4,
  flexShrink: 0,
};

export const menuEmptyStyle = {
  padding: '16px 12px',
  color: 'var(--tm)',
  fontSize: 12,
  fontStyle: 'italic',
  textAlign: 'center',
};

/* ── Attach menu ─────────────────────────────────────────── */

export const attachMenuStyle = {
  position: 'absolute',
  left: 8,
  bottom: '100%',
  marginBottom: 6,
  width: 220,
  zIndex: 1200,
  background: 'var(--card, var(--bg))',
  border: '1px solid var(--bdr)',
  borderRadius: 10,
  boxShadow: 'var(--shc)',
  display: 'flex',
  flexDirection: 'column',
  padding: '4px 0',
};

export const attachItemStyle = {
  display: 'flex',
  alignItems: 'center',
  gap: 10,
  width: '100%',
  minHeight: 44,
  padding: '8px 12px',
  border: 'none',
  background: 'transparent',
  color: 'var(--t1)',
  fontSize: 13,
  cursor: 'pointer',
  fontFamily: 'inherit',
  textAlign: 'left',
};
